<template>
  <div class="upload-image-div">
    <div class="upload-image">
      <h1>Upload Image</h1>
      <!-- <FileInput
                ref="fileInput"
                :userId="user.uid"
                :healthTypeId="healthTypeId"
      ></FileInput>-->
      <FileInput></FileInput>
    </div>
  </div>
</template>

<script>
// import dragAndDrop from "@/mixins/dragAndDrop";
import FileInput from "./FileInput.vue";

export default {
  data() {
    return {};
  },
  methods: {},
  components: { FileInput }
};
</script>

<style scoped>
.upload-image-div {
  padding-top: 5vh;
  margin-left: 5vw;
}

.upload-image {
  display: flex;
  flex-direction: column;
  width: 80vh;
  height: 80vh;
  background: #fffffff0;
  border-radius: 50%;
  padding: 30px;
  border: 7px solid #f62d14;
}
</style>